// extracted by mini-css-extract-plugin
export default {"wrapper":"KfSBPe","mobile":"CvNcKq","headline":"n4mt7i","description":"rzUnJU","items":"UYPggS","withMarkup":"YCpXyo","component":"G5X5CB","goods":"JDg4oE","col":"nAtb9l"};